import React, { useState } from 'react';

import { Card } from 'common/api/e-comm/models/Card';
import { useArchivedCards } from 'common/hooks/useArchivedCards';
import WalletCard from '../components/WalletCard';
import { WalletSortAndFilter } from './sortAndFilter';
import Skeleton from 'react-loading-skeleton';
import UnArchiveCardModal from '../components/UnArchiveCardModal';

const EmptyResultsMessage = () => (
    <div className="text-lg py-36 text-brand text-center sm:text-2xl">
        No matching results. <br />
        Select another filter to view your cards
    </div>
);

const useUnArchiveModalControls = () => {
    const [cardToArchive, setCardToArchiveTo] = useState<string | null>(null);

    return {
        card: cardToArchive,
        isOpen: Boolean(cardToArchive),
        closeModal: () => setCardToArchiveTo(null),
        openModal: setCardToArchiveTo,
    };
};

export const ArchivedView = ({ isActive }: { isActive: boolean }) => {
    const [hasFetchedCards, setHasFetchedCards] = useState<boolean>(false);
    const { archivedCards, refresh } = useArchivedCards(setHasFetchedCards);
    const [cardsToRender, setCardsToRender] = useState<Card[]>([]);
    const { card, isOpen, closeModal, openModal } = useUnArchiveModalControls();

    if (!isActive) {
        return null;
    }

    if (!hasFetchedCards) {
        return (
            <div className="w-4/5 m-auto my-10">
                <Skeleton className="h-20" />
                <Skeleton className="mt-10 h-60" />
            </div>
        );
    }

    return (
        <>
            <div>
                <div className="text-3xl text-brand-dark mb-8">Archived Cards</div>
            </div>
            <WalletSortAndFilter
                allCards={archivedCards}
                setViewableCards={setCardsToRender}
                result={cardsToRender.length || 0}
                shouldResetFilters={isActive}
                shouldPersistFilters={false}
            />
            <UnArchiveCardModal
                isOpen={isOpen}
                closeModal={closeModal}
                cardId={card || ''}
                refreshArchivedCards={refresh}
            />
            {cardsToRender.length > 0 ? (
                cardsToRender.map((card, index) => (
                    <WalletCard
                        idx={index}
                        key={card.id}
                        card={card}
                        archived={isActive}
                        openUnArchiveModal={openModal}
                    />
                ))
            ) : (
                <EmptyResultsMessage />
            )}
        </>
    );
};
